import * as keys from '../../constants';

const defaultState = {
  today: {},
  yesterday: {},
  tomorrow: {},
};

class LocalStorageUtility {
  static updateMatch(sportId, matchId, date) {
    let tsForDate;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const yesterdayDate = new Date(today);
    const yesterdayRef = new Date(yesterdayDate.setDate(today.getDate() - 1));
    const tomorrowDate = new Date(today);
    const tomorrowRef = new Date(tomorrowDate.setDate(today.getDate() + 1));
    switch (date) {
      case 'today':
        tsForDate = today.getTime();
        break;
      case 'yesterday':
        tsForDate = yesterdayRef.getTime();
        break;
      case 'tomorrow':
        tsForDate = tomorrowRef.getTime();
        break;
      default:
        break;
    }
    const preferred = JSON.parse(localStorage.getItem(keys.PREFERRED_MATCH))
      ? JSON.parse(localStorage.getItem(keys.PREFERRED_MATCH))
      : defaultState;
    const preferredMap = JSON.parse(localStorage.getItem(keys.PREFERRED_MAP))
      ? JSON.parse(localStorage.getItem(keys.PREFERRED_MAP))
      : {};
    const currentDateMap = preferred[date];
    let sportMap = currentDateMap[sportId];
    if (!sportMap) {
      sportMap = {};
    }
    if (sportMap[matchId]) {
      delete sportMap[matchId];
      delete preferredMap[matchId];
      this.decrementCounter();
    } else {
      sportMap[matchId] = tsForDate;
      preferredMap[matchId] = tsForDate;
      this.incrementCounter();
    }
    currentDateMap[sportId] = sportMap;
    if (!Object.keys(currentDateMap[sportId]).length) {
      delete currentDateMap[sportId];
    }
    preferred[date] = currentDateMap;
    localStorage.setItem(keys.PREFERRED_MATCH, JSON.stringify(preferred));
    localStorage.setItem(keys.PREFERRED_MAP, JSON.stringify(preferredMap));
  }

  static incrementCounter() {
    let counter = Number(localStorage.getItem(keys.PREFERRED_COUNTER));
    counter += 1;
    localStorage.setItem(keys.PREFERRED_COUNTER, counter);
  }

  static decrementCounter() {
    let counter = Number(localStorage.getItem(keys.PREFERRED_COUNTER));
    counter -= 1;
    localStorage.setItem(keys.PREFERRED_COUNTER, counter);
  }

  static getPreferredCounter() {
    return localStorage.getItem(keys.PREFERRED_COUNTER) ? Number(localStorage.getItem(keys.PREFERRED_COUNTER)) : 0;
  }

  static getPreferredMatch() {
    return localStorage.getItem(keys.PREFERRED_MAP) ? JSON.parse(localStorage.getItem(keys.PREFERRED_MAP)) : {};
  }

  static clearStorage() {
    localStorage.clear();
  }

  static getYesterdaySportIds() {
    const preferred = JSON.parse(localStorage.getItem(keys.PREFERRED_MATCH))
      ? JSON.parse(localStorage.getItem(keys.PREFERRED_MATCH))
      : defaultState;
    return Object.keys(preferred.yesterday);
  }

  static getTomorrowSportIds() {
    const preferred = JSON.parse(localStorage.getItem(keys.PREFERRED_MATCH))
      ? JSON.parse(localStorage.getItem(keys.PREFERRED_MATCH))
      : defaultState;
    return Object.keys(preferred.tomorrow);
  }

  static getTodaySportIds() {
    const preferred = JSON.parse(localStorage.getItem(keys.PREFERRED_MATCH))
      ? JSON.parse(localStorage.getItem(keys.PREFERRED_MATCH))
      : defaultState;
    return Object.keys(preferred.today);
  }

  static hasSportIds(type) {
    const preferred = JSON.parse(localStorage.getItem(keys.PREFERRED_MATCH))
      ? JSON.parse(localStorage.getItem(keys.PREFERRED_MATCH))
      : defaultState;
    return !!Object.keys(preferred[type]).length;
  }

  static isYesterday(timestamp) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const yesterdayDate = new Date(today);
    const yesterdayRef = new Date(yesterdayDate.setDate(today.getDate() - 1));
    const currentDay = new Date(timestamp);
    currentDay.setHours(0, 0, 0, 0);
    return yesterdayRef.getTime() === currentDay.getTime();
  }

  static isToday(timestamp) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const currentDay = new Date(timestamp);
    currentDay.setHours(0, 0, 0, 0);
    return today.getTime() === currentDay.getTime();
  }

  static updateLocalStorage() {
    const preferred = JSON.parse(localStorage.getItem(keys.PREFERRED_MATCH))
      ? JSON.parse(localStorage.getItem(keys.PREFERRED_MATCH))
      : defaultState;
    const preferredMap = JSON.parse(localStorage.getItem(keys.PREFERRED_MAP))
      ? JSON.parse(localStorage.getItem(keys.PREFERRED_MAP))
      : {};
    Object.keys(preferred.yesterday).forEach((sport) => {
      const yesterdaySport = preferred.yesterday[sport];
      Object.keys(yesterdaySport).forEach((matchId) => {
        if (!this.isYesterday(yesterdaySport[matchId])) {
          delete preferredMap[matchId];
          delete yesterdaySport[matchId];
          this.decrementCounter();
        }
      });
      preferred.yesterday[sport] = yesterdaySport;
      if (!Object.keys(preferred.yesterday[sport]).length) {
        delete preferred.yesterday[sport];
      }
    });
    Object.keys(preferred.today).forEach((sport) => {
      const todaySport = preferred.today[sport];
      const mapForYesterday = {};
      Object.keys(todaySport).forEach((matchId) => {
        if (!this.isToday(todaySport[matchId])) {
          mapForYesterday[matchId] = todaySport[matchId];
          delete todaySport[matchId];
        }
      });
      if (preferred.yesterday[sport]) {
        Object.assign(preferred.yesterday[sport], mapForYesterday);
      } else if (Object.keys(mapForYesterday).length) {
        preferred.yesterday[sport] = mapForYesterday;
      }


      preferred.today[sport] = todaySport;
      if (!Object.keys(preferred.today[sport]).length) {
        delete preferred.today[sport];
      }
    });
    Object.keys(preferred.tomorrow).forEach((sport) => {
      const tomorrowSport = preferred.tomorrow[sport];
      const mapForToday = {};
      Object.keys(tomorrowSport).forEach((matchId) => {
        if (this.isToday(tomorrowSport[matchId])) {
          mapForToday[matchId] = tomorrowSport[matchId];
          delete tomorrowSport[matchId];
        }
      });
      if (preferred.today[sport]) {
        Object.assign(preferred.today[sport], mapForToday);
      } else if (Object.keys(mapForToday).length) {
        preferred.today[sport] = mapForToday;
      }

      preferred.tomorrow[sport] = tomorrowSport;
      if (!Object.keys(preferred.tomorrow[sport]).length) {
        delete preferred.tomorrow[sport];
      }
    });

    localStorage.setItem(keys.PREFERRED_MATCH, JSON.stringify(preferred));
    localStorage.setItem(keys.PREFERRED_MAP, JSON.stringify(preferredMap));
  }

  static getSessionCounter() {
    return localStorage.getItem(keys.SESSION_COUNTER) ? Number(localStorage.getItem(keys.SESSION_COUNTER)) : 0;
  }

  static incrementSessionCounter() {
    let counter = Number(localStorage.getItem(keys.SESSION_COUNTER));
    counter += 1;
    localStorage.setItem(keys.SESSION_COUNTER, counter);
  }

  static isPreferred(matchId) {
    return !!this.getPreferredMatch()[matchId];
  }

  static hasNewFeatures() {
    if (localStorage.getItem(keys.NEW_FEATURES)) { return true; }
    return false;
  }

  static setNewFeatures() {
    localStorage.setItem(keys.NEW_FEATURES, true);
  }
}

export default LocalStorageUtility;
